import Grid from "@mui/material/Grid";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

import KeepMountedModal from '../../../../components/Modal/index.js'
import AddNewRevenueExpenseForm from './addNewRevenueExpenseForm.js'
import { useState } from "react";
import { completeOnboarding } from "utils/onboarding";

const REVENUE_EXPENSES_ONBOARDING_KEY = "patrimonio360onboarding-revenuexexpenses";

function ReceitaXDespesa(props) {
  const { closeOnboarding, openSnackBar, refreshList } = props;
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
    completeOnboarding(REVENUE_EXPENSES_ONBOARDING_KEY);
    closeOnboarding(false);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <Grid onClick={handleOpenModal} item xs={12} md={12} xl={12}>
        <DefaultInfoCard
          classProp="addRevenueExpense"
          icon="add"
          title="Adicionar"
          description="Adicionar receita ou despesa"
          // value={`R$ ${remaningValue}` }
          // value={'Adicionar'}
          height="8rem"
          width="8rem"
          iconSize="large"
        />
      </Grid>
      <KeepMountedModal
        className="modalRevenueExpenses"
        title="Nova receita ou despesa"
        content={<AddNewRevenueExpenseForm
          openSnackBar={(e) => openSnackBar(e)}
          title="Nova receita ou despesa"
          closeModal={handleCloseModal}
          refreshList={refreshList}
          />
        }
        closeModal={handleCloseModal}
        isOpen={openModal} // Passa o estado diretamente
      />
    </>
  );
}


export default ReceitaXDespesa;
